import { render, staticRenderFns } from "./PlayerBestSession.vue?vue&type=template&id=98b30d5c&"
import script from "./PlayerBestSession.vue?vue&type=script&lang=js&"
export * from "./PlayerBestSession.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports